import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const Notification = (props) => {
  const [error, setError] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const apiUrl = process.env.REACT_APP_SOCKET_URL;

  useEffect(() => {
    try {
      const newSocket = io(`${apiUrl}`,{
        withCredentials: true
    });

      newSocket.on('connect', () => {});

      newSocket.emit('userConnect', props.userData.user.donnée.results[0].id, props.userData.user.type);

      newSocket.on('message', (receivedMessage) => {
        setNotifications((prevNotifications) => [
          ...prevNotifications,
          { id: Date.now(), nom_exp: receivedMessage.nom_exp, logo: receivedMessage.logo, date: receivedMessage.date , show: true },
        ]);

        setTimeout(() => {
          setNotifications((prevNotifications) => 
            prevNotifications.map((notification) => 
              notification.id === receivedMessage.id ? { ...notification, show: false } : notification
            )
          );
        }, 20000);
      });

      newSocket.on('disconnect', () => {});

      return () => {
        newSocket.disconnect();
      };
    } catch (error) {
      setError(true);
    }
  }, [apiUrl, props.userData.user.donnée.results, props.userData.user.type]);

  return (
    <>   
      {error && 
        <div id="alert-message" className="alert4">
          <strong>ERROR ! </strong>Erreur notification <span id="alert-text"></span>
        </div>
      }
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1050, position: 'fixed' }}>
        {notifications.map((notification) => (
          <Toast
            key={notification.id}
            onClose={() => setNotifications((prevNotifications) => 
              prevNotifications.filter((n) => n.id !== notification.id)
            )}
            show={notification.show}
            delay={20000}
            autohide
          >
            <Toast.Header>
              <img
                style={{width: '25px', borderRadius : '50%'}}
                src='/img/notification.png' 
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">{notification.nom_exp}</strong>
            </Toast.Header>
              <Toast.Body>
                {notification.date}:  Nouveau message
              </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </>
  );
};

export default Notification;
